<!-- <div class="justify-content-between mobile-view">
  <a (click)="fliterOpen = !fliterOpen" class="filter">Filters</a>
</div> -->
<div class="wrap-filters" [ngClass]="{ 'fliter-open': fliterOpen }">
  <h2 class="mobile-title">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2.94193C0 2.64263 0.249888 2.39999 0.55814 2.39999H15.4419C15.7501 2.39999 16 2.64263 16 2.94193C16 3.24123 15.7501 3.48386 15.4419 3.48386H0.55814C0.249888 3.48386 0 3.24123 0 2.94193ZM2.48062 7.99999C2.48062 7.70069 2.73051 7.45806 3.03876 7.45806H12.9612C13.2695 7.45806 13.5194 7.70069 13.5194 7.99999C13.5194 8.2993 13.2695 8.54193 12.9612 8.54193H3.03876C2.73051 8.54193 2.48062 8.2993 2.48062 7.99999ZM5.45736 13.0581C5.45736 12.7588 5.70725 12.5161 6.0155 12.5161H9.9845C10.2927 12.5161 10.5426 12.7588 10.5426 13.0581C10.5426 13.3574 10.2927 13.6 9.9845 13.6H6.0155C5.70725 13.6 5.45736 13.3574 5.45736 13.0581Z" fill="black"/>
    </svg> 
    Filters
  </h2>
  <!-- <div class="inner-filter-wrap company-filterWrap">
    <h2 class="filter-title">Company Type</h2>
    <form class="filter-list">
      <label class="checkbox__label" *ngFor="let item of TYPE_OF_COMPANY">
        {{ item.label }}
        <input
          type="checkbox"
          class="checkbox__input"
          [name]="item.key"
          [id]="item.key"
          [value]="item.key"
          (change)="typeFilterChanged(item.key)"
        />
        <span class="checkbox__mark"></span>
      </label>
    </form>
  </div> -->
  <!--Add new filter for compnay in the design-->
  <!-- <div class="inner-filter-wrap operation-filterWrap">
    <h2 class="filter-title">Operation Status</h2>
    <form class="filter-list">
      <label class="checkbox__label">
        Active
        <input
          type="checkbox"
          class="checkbox__input"
          [name]=""
          [id]=""
          [value]=""

        />
        <span class="checkbox__mark"></span>
      </label>
      <label class="checkbox__label">
        Shutdown
        <input
          type="checkbox"
          class="checkbox__input"
          [name]=""
          [id]=""
          [value]=""

        />
        <span class="checkbox__mark"></span>
      </label>
      <label class="checkbox__label">
        Made Aquisitions
        <input
          type="checkbox"
          class="checkbox__input"
          [name]=""
          [id]=""
          [value]=""

        />
        <span class="checkbox__mark"></span>
      </label>
      <label class="checkbox__label">
        Was Acquired
        <input
          type="checkbox"
          class="checkbox__input"
          [name]=""
          [id]=""
          [value]=""

        />
        <span class="checkbox__mark"></span>
      </label>
      <label class="checkbox__label">
        Funded
        <input
          type="checkbox"
          class="checkbox__input"
          [name]=""
          [id]=""
          [value]=""

        />
        <span class="checkbox__mark"></span>
      </label>
      <label class="checkbox__label">
        Non Funded
        <input
          type="checkbox"
          class="checkbox__input"
          [name]=""
          [id]=""
          [value]=""

        />
        <span class="checkbox__mark"></span>
      </label>
    </form>
  </div> -->
  <!--End new added filter-->

  <!-- <div class="inner-filter-wrap industry-filterWrap">
    <h2 class="filter-title">Industry</h2>
    <div class="input-wrap">
      <input
        type="search"
        placeholder="Search"
        aria-label="Search"
        #industryInput
        class="form-control"
        (input)="filterIndustryFilter(industryInput.value)"
      />
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8161 10.7955L9.09574 8.07515C9.75068 7.20326 10.1042 6.14199 10.103 5.05152C10.103 2.26613 7.83691 0 5.05152 0C2.26613 0 0 2.26613 0 5.05152C0 7.83691 2.26613 10.103 5.05152 10.103C6.14199 10.1042 7.20326 9.75068 8.07515 9.09574L10.7955 11.8161C10.9332 11.9392 11.1128 12.0049 11.2974 11.9997C11.482 11.9946 11.6577 11.9189 11.7883 11.7883C11.9189 11.6577 11.9946 11.482 11.9997 11.2974C12.0049 11.1128 11.9392 10.9332 11.8161 10.7955ZM1.44329 5.05152C1.44329 4.33788 1.65491 3.64027 2.05139 3.0469C2.44786 2.45353 3.01139 1.99105 3.67071 1.71795C4.33003 1.44485 5.05552 1.3734 5.75545 1.51262C6.45538 1.65185 7.0983 1.9955 7.60292 2.50012C8.10754 3.00474 8.45119 3.64766 8.59042 4.34759C8.72964 5.04752 8.65819 5.77301 8.38509 6.43233C8.11199 7.09165 7.64951 7.65518 7.05614 8.05165C6.46277 8.44813 5.76516 8.65975 5.05152 8.65975C4.09491 8.6586 3.17781 8.27808 2.50138 7.60166C1.82496 6.92523 1.44444 6.00813 1.44329 5.05152Z" fill="black"/>
      </svg>
    </div>
    <div class="filter-list filterlist-wrap">
      <label
        class="checkbox__label"
        [ngClass]="{ invisible: !isExpandedIndustry && i > 4 }"
        *ngFor="let item of INDUSTRY; index as i"
      >
        {{ item.label }}
        <input
          type="checkbox"
          class="checkbox__input"
          [name]="item.key"
          [id]="item.key"
          [value]="item.key"
          (change)="industryFilterChanged(item.key)"
        />
        <span class="checkbox__mark"></span>
      </label>
      <span
        [ngClass]="{ expanded: isExpandedIndustry }"
        (click)="isExpandedIndustry = !isExpandedIndustry"
        >{{ isExpandedIndustry ? "Collapse" : "Expand" }}</span
      >
    </div>
  </div> -->
  <!-- <div class="inner-filter-wrap location-filterWrap">
    <div class="d-flex justify-content-between">
      <h2 class="filter-title">Location</h2>
    </div>
    <div class="input-wrap">
      <input
      type="search"
      placeholder="Search"
      aria-label="Search"
      #locationInput
      class="form-control"
      (input)="filterLocationFilter(locationInput.value)"
      />
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8161 10.7955L9.09574 8.07515C9.75068 7.20326 10.1042 6.14199 10.103 5.05152C10.103 2.26613 7.83691 0 5.05152 0C2.26613 0 0 2.26613 0 5.05152C0 7.83691 2.26613 10.103 5.05152 10.103C6.14199 10.1042 7.20326 9.75068 8.07515 9.09574L10.7955 11.8161C10.9332 11.9392 11.1128 12.0049 11.2974 11.9997C11.482 11.9946 11.6577 11.9189 11.7883 11.7883C11.9189 11.6577 11.9946 11.482 11.9997 11.2974C12.0049 11.1128 11.9392 10.9332 11.8161 10.7955ZM1.44329 5.05152C1.44329 4.33788 1.65491 3.64027 2.05139 3.0469C2.44786 2.45353 3.01139 1.99105 3.67071 1.71795C4.33003 1.44485 5.05552 1.3734 5.75545 1.51262C6.45538 1.65185 7.0983 1.9955 7.60292 2.50012C8.10754 3.00474 8.45119 3.64766 8.59042 4.34759C8.72964 5.04752 8.65819 5.77301 8.38509 6.43233C8.11199 7.09165 7.64951 7.65518 7.05614 8.05165C6.46277 8.44813 5.76516 8.65975 5.05152 8.65975C4.09491 8.6586 3.17781 8.27808 2.50138 7.60166C1.82496 6.92523 1.44444 6.00813 1.44329 5.05152Z" fill="black"/>
      </svg>
    </div>
    <div class="filter-list filterlist-wrap">
      <label
        class="checkbox__label"
        [ngClass]="{ invisible: !isExpandedLLocation && i > 4 }"
        *ngFor="let item of LOCATION; index as i"
      >
        {{ item.label }}
        <input
          type="checkbox"
          class="checkbox__input"
          [name]="item.key"
          [id]="item.key"
          [value]="item.key"
          (change)="locationFilterChanged(item.key)"
        />
        <span class="checkbox__mark"></span>
      </label>
      <span
        [ngClass]="{ expanded: isExpandedLLocation }"
        (click)="isExpandedLLocation = !isExpandedLLocation"
        >{{ isExpandedLLocation ? "Collapse" : "Expand" }}</span
      >
    </div>
  </div> -->
  <button
    *ngIf="fliterOpen"
    (click)="fliterOpen = !fliterOpen"
    class="btn btn-outline-light btn-blue-bg"
  >
    Apply Filters
  </button>

  <!--new filters for Report page-->
  <!-- <div class="inner-filter-wrap searchWrap">
    <label>Search your Report</label>
    <div class="input-wrap">
      <input
        type="search"
        placeholder="eg. Weekly funding report..."
        aria-label="Search"
        class="form-control"
        #typeInput
        (input)="filterTypeFilter(typeInput.value)"
      />
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8161 10.7955L9.09574 8.07515C9.75068 7.20326 10.1042 6.14199 10.103 5.05152C10.103 2.26613 7.83691 0 5.05152 0C2.26613 0 0 2.26613 0 5.05152C0 7.83691 2.26613 10.103 5.05152 10.103C6.14199 10.1042 7.20326 9.75068 8.07515 9.09574L10.7955 11.8161C10.9332 11.9392 11.1128 12.0049 11.2974 11.9997C11.482 11.9946 11.6577 11.9189 11.7883 11.7883C11.9189 11.6577 11.9946 11.482 11.9997 11.2974C12.0049 11.1128 11.9392 10.9332 11.8161 10.7955ZM1.44329 5.05152C1.44329 4.33788 1.65491 3.64027 2.05139 3.0469C2.44786 2.45353 3.01139 1.99105 3.67071 1.71795C4.33003 1.44485 5.05552 1.3734 5.75545 1.51262C6.45538 1.65185 7.0983 1.9955 7.60292 2.50012C8.10754 3.00474 8.45119 3.64766 8.59042 4.34759C8.72964 5.04752 8.65819 5.77301 8.38509 6.43233C8.11199 7.09165 7.64951 7.65518 7.05614 8.05165C6.46277 8.44813 5.76516 8.65975 5.05152 8.65975C4.09491 8.6586 3.17781 8.27808 2.50138 7.60166C1.82496 6.92523 1.44444 6.00813 1.44329 5.05152Z" fill="black"/>
      </svg>
    </div>
  </div> -->
  <div class="inner-filter-wrap category-filterWrap">
    <h2 class="filter-title">Category</h2>
    <form class="filter-list">
      <label class="checkbox__label" *ngFor="let item of INDUSTRY_REPORT_CATEGORY">
        {{ item.label }}
        <input
          type="checkbox"
          class="checkbox__input"
          [name]="item.key"
          [id]="item.key"
          [value]="item.key"
          (change)="categoryFilterChanged(item.code)"
        />
        <span class="checkbox__mark"></span>
      </label>
    </form>
  </div>

  <div *ngIf="TYPE_OF_COMPANY?.length>0" class="inner-filter-wrap type-filterWrap">
    <h2 class="filter-title">Type</h2>
    <!-- <div class="input-wrap">
      <input
      type="search"
      placeholder="Search"
      aria-label="Search"
      #industryInput
      class="form-control"
      (input)="filterIndustryFilter(industryInput.value)"
      />
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8161 10.7955L9.09574 8.07515C9.75068 7.20326 10.1042 6.14199 10.103 5.05152C10.103 2.26613 7.83691 0 5.05152 0C2.26613 0 0 2.26613 0 5.05152C0 7.83691 2.26613 10.103 5.05152 10.103C6.14199 10.1042 7.20326 9.75068 8.07515 9.09574L10.7955 11.8161C10.9332 11.9392 11.1128 12.0049 11.2974 11.9997C11.482 11.9946 11.6577 11.9189 11.7883 11.7883C11.9189 11.6577 11.9946 11.482 11.9997 11.2974C12.0049 11.1128 11.9392 10.9332 11.8161 10.7955ZM1.44329 5.05152C1.44329 4.33788 1.65491 3.64027 2.05139 3.0469C2.44786 2.45353 3.01139 1.99105 3.67071 1.71795C4.33003 1.44485 5.05552 1.3734 5.75545 1.51262C6.45538 1.65185 7.0983 1.9955 7.60292 2.50012C8.10754 3.00474 8.45119 3.64766 8.59042 4.34759C8.72964 5.04752 8.65819 5.77301 8.38509 6.43233C8.11199 7.09165 7.64951 7.65518 7.05614 8.05165C6.46277 8.44813 5.76516 8.65975 5.05152 8.65975C4.09491 8.6586 3.17781 8.27808 2.50138 7.60166C1.82496 6.92523 1.44444 6.00813 1.44329 5.05152Z" fill="black"/>
      </svg>
    </div> -->

    <div class="filter-list filterlist-wrap">
      <label
        class="checkbox__label"
        [ngClass]="{ invisible: !isExpandedIndustry && i > 4 }"
        *ngFor="let item of TYPE_OF_COMPANY; index as i"
      >
        {{ item.label }}
        <input
          type="checkbox"
          class="checkbox__input"
          [name]="item.key"
          [id]="item.key"
          [value]="item.key"
          (change)="typeFilterChanged(item.code)"
        />
        <span class="checkbox__mark"></span>
      </label>
      <span
        [ngClass]="{ expanded: isExpandedIndustry }"
        (click)="isExpandedIndustry = !isExpandedIndustry"
        >{{ isExpandedIndustry ? "Collapse" : "Expand" }}</span
      >
    </div>
  </div>

  <div class="inner-filter-wrap category-filterWrap">
    <h2 class="filter-title">Date</h2>
    <form class="filter-list">
      <label class="checkbox__label" *ngFor="let item of DATE_OF_COMPANY">
        {{ item.label }}
        <input
          type="checkbox"
          class="checkbox__input"
          [name]="item.key"
          [id]="item.key"
          [value]="item.key"
          (change)="dateFilterChanged(item.code)"
        />
        <span class="checkbox__mark"></span>
      </label>
    </form>
  </div>

</div>
